export const pagesEstacio = [
    // {
    //     nome: 'Lojas',
    //     url: '/lojas'
    // },
    // {
    //     nome: 'Categorias',
    //     url: '/categorias'
    // },
    {
        nome: 'Ajuda',
        url: '/ajuda/perguntas-frequentes?utm_source=clube-do-aluno'
    },
    {
        nome: 'Fale Conosco',
        url: '/institucional/contato'
    }
]